var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfobutton(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6895 17.6094V16.9514L11.4455 16.7834C11.4549 16.4474 11.4595 16.0834 11.4595 15.6914C11.4595 15.2994 11.4595 14.9587 11.4595 14.6694V13.9974C11.4595 13.6147 11.4549 13.2974 11.4455 13.0454C11.4455 12.784 11.4362 12.5134 11.4175 12.2334L10.5495 12.1074V11.5614L13.4895 10.6234L13.7275 10.7774L13.6855 12.8074V14.6694C13.6855 14.9587 13.6855 15.304 13.6855 15.7054C13.6855 16.0974 13.6902 16.466 13.6995 16.8114L14.3995 16.9514V17.6094H10.6895ZM12.5515 9.58737C12.2249 9.58737 11.9449 9.48471 11.7115 9.27937C11.4782 9.06471 11.3615 8.79871 11.3615 8.48137C11.3615 8.15471 11.4782 7.88871 11.7115 7.68337C11.9449 7.46871 12.2249 7.36137 12.5515 7.36137C12.8782 7.36137 13.1582 7.46871 13.3915 7.68337C13.6249 7.88871 13.7415 8.15471 13.7415 8.48137C13.7415 8.79871 13.6249 9.06471 13.3915 9.27937C13.1582 9.48471 12.8782 9.58737 12.5515 9.58737Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.75,
    cy: 12.75,
    r: 8.25,
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfobutton);
export default __webpack_public_path__ + "static/media/Info button.5e9c240f0afa085f41bb69c614e8516b.svg";
export { ForwardRef as ReactComponent };